<template>
  <div>
    <wc-page-title title='Templates'>
      <template v-slot:rightSide>
        <v-menu offset-y left>
          <template v-slot:activator='{ on }'>
            <v-btn icon small v-on='on'><v-icon>mdi-plus</v-icon></v-btn>
          </template>
          <v-list dense>
            <v-subheader>NEW TEMPLATE FOR</v-subheader>
            <v-divider></v-divider>
            <v-list-item v-for='d in divisions' :key='d.id' @click='startNewTemplate(d)'>
              <v-list-item-icon>
                <v-icon v-text='d.icon' :color='d.icon_color'></v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ d.division }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
        <wc-toolbar-search v-model='search'></wc-toolbar-search>
        <wc-show-archived-button v-model='showArchived' @toggleShowArchived='showArchived = !showArchived'></wc-show-archived-button>
      </template>
    </wc-page-title>

    <v-container>
      <v-row>
        <v-col cols='12'>
          <wc-data-box hideToolbar>
            <v-data-table
              :items='filteredTemplates'
              :headers='headers'
              :search='search'
              @click:row='openTemplate'
              dense
            >
              <template v-slot:item.name='{ item }'>
                {{ item.name }} <wc-archived v-if='item.archived'></wc-archived>
              </template>
              <template v-slot:item.division='{ item }'>
                <wc-division-nai :division_obj='item.division_obj'></wc-division-nai>
              </template>
            </v-data-table>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>

    <wc-dialog
      :title='dialogTitle'
      :icon='dialogIcon'
      :showDialog='showNewDialog'
      saveText='Create'
      @cancel='cancelCreate'
      @save='createTemplate'
      :disableButtons='!isFormValid'
      :loadingButtons='isLoading'
      width='350'
    >
      <v-form ref='form' v-model='isFormValid'>
        <v-text-field
          :rules='[rules.required]'
          label='Template Name'
          hint='For easy reference when starting an actual estimate'
          v-model='newTemplate.name'
        ></v-text-field>
      </v-form>
    </wc-dialog>

  </div>
</template>

<script>
import estimatesAPI from '../api/estimates'
import formRules from '@/mixins/formRules'
import WCDivisionNAI from '@/components/misc/WCDivisionNAI'

export default {
  name: 'estimate-templates',
  mixins: [formRules],
  data: () => ({
    isLoading: false,
    isFormValid: false,
    showArchived: false,
    showNewDialog: false,
    dialogTitle: '',
    dialogIcon: '',
    search: '',
    headers: [
      { text: 'Name', value: 'name' },
      { text: 'Division', value: 'division' }
    ],
    templates: [],
    newTemplate: {
      is_template: true,
      division: null,
      name: ''
    }
  }),
  computed: {
    divisions () {
      return this.$store.state.misc.divisions
    },
    filteredTemplates () {
      return this.showArchived ? this.templates : this.templates.filter(t => t.archived === false)
    }
  },
  created () {
    this.getTemplates()
  },
  methods: {
    startNewTemplate (div) {
      this.newTemplate.division = div.id
      this.dialogTitle = 'New ' + div.division + ' Template'
      this.dialogIcon = div.icon
      this.showNewDialog = true
    },
    cancelCreate () {
      this.$refs.form.reset()
      this.showNewDialog = false
    },
    async getTemplates () {
      this.isLoading = true
      this.templates = await estimatesAPI.getEstimateTemplates()
      this.isLoading = false
    },
    getDivision (item) {
      return this.divisions.find(d => d.id === item.division).division
    },
    openTemplate (template) {
      const routeName = this.getDivision(template) + 'Template'
      this.$router.push({ name: routeName, params: { id: template.id } })
    },
    async createTemplate () {
      this.isLoading = true
      const newEst = await estimatesAPI.createEstimateTemplate(this.newTemplate)
      this.$router.push({ name: 'SnowTemplate', params: { id: newEst.id } })
    }
  },
  components: {
    'wc-division-nai': WCDivisionNAI
  }
}
</script>
